import { DEFAULT_FILE_TYPES } from '~/components/Admin/IntegrationPage/constants';
import { CrmType } from '~/enums/CrmType';
import { ProcurementIntegrationType } from '~/enums/ProcurementIntegrationType';
import { StorageProviderType } from '~/enums/StorageProviderType';

interface SyncPairData {
  name: string;
  provider: StorageProviderType | CrmType | ProcurementIntegrationType;
  tokenId?: string;
  allowedSyncFileTypes?: string[];
}

export const createSyncPairData = (data: SyncPairData) => {
  const defaults = {
    allowedSyncFileTypes: DEFAULT_FILE_TYPES,
  };
  return { ...defaults, ...data };
};
